import AuthHeader from "components/AuthHeader";
import NonAuthLayoutWrapper from "components/NonAutnLayoutWrapper";
import { useRedux } from "hooks";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { APIClient } from "../../api/apiCore";
import * as urls from "../../api/urls";

import {
    getChatUserDetails2s
    , readConversation, getChatUserConversations2, changeSelectedChat
    , setActiveGroupId

} from "../../../src/redux/actions";
import LoadingIconWithText from "components/LoadingIconWithText";

const InviteRedirection = () => {
    const { dispatch, useAppSelector } = useRedux();
    const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { ivcode } = useParams<{ ivcode: string }>();
    const [loading, setLoading] = useState<boolean>(true);
    const [statusText, setStatusText] = useState<string>("กำลังตรวจเช็คข้อมูล...");

    useEffect(() => {
        const checkInviteCode = async () => {
            try {
                if (ivcode) {
                    const api = new APIClient();
                    const rs = await api.fnPostForm(urls.CHECK_GROUP_INVITE_CODE, { groupInviteCode: ivcode });
                    if (rs.err) {
                        setStatusText(rs.err);
                    } else {
                        setRedirectUrl("/auth-register-phone?iv=" + ivcode);
                    }
                } else {
                    setRedirectUrl("/");
                }
            } catch (e) {
                setStatusText((e as any).message);
            }
            setLoading(false);
        }

        checkInviteCode();
    }, [location]);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    return (
        <NonAuthLayoutWrapper>
            <Row className=" justify-content-center my-auto">
                <Col sm={8} lg={6} xl={5} className="col-xxl-4">
                    <div className="py-md-5 py-4">
                        <AuthHeader
                            title={"ยินดีต้อนรับสู่ " + process.env.REACT_APP_NAME}
                            subtitle={""}
                        />


                        <div className="alert alert-danger fz-13 text-center">
                            {loading && (<LoadingIconWithText loadingText={""} />)}                           
                            {statusText}
                        </div>

                        <div className="mt-5 text-center text-muted">
                            <p>
                                <Link
                                    //to="/auth-login"
                                    to="/dashboard"
                                    className="fw-medium text-decoration-underline"
                                >
                                    กลับหน้าหลัก
                                </Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </NonAuthLayoutWrapper>
    );
}

export default InviteRedirection;